<iframe
  [src]="safeLegacyAppUrl"
  style="position: fixed; top: 6.6rem; left: 0; right: 0; width: 100%; height: calc(100% - 54px - (var(--spacing) * 8)); border: none;"
></iframe>
